import React from "react";

const FONT_SIZES = [11, 12, 13, 14, 15, 16, 18, 20, 22, 24];

function ToolButton({ active, onClick, label, icon, wide = false }) {
  return (
    <button
      type="button"
      className={`lh6-toolBtn ${wide ? "is-wide" : ""} ${active ? "is-active" : ""}`}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      {icon || label}
    </button>
  );
}

export default function TiptapToolbar({
  htmlMode,
  format,
  color,
  fontSize,
  colors,
  activeMarks,
  formulaSelected,
  imageSelected,
  imageLayout,
  onFormatChange,
  onInsertTable,
  onHorizontalLine,
  onFontSizeChange,
  onBold,
  onItalic,
  onColor,
  onBullets,
  onNumbers,
  onSup,
  onSub,
  onLink,
  onInsertImage,
  onImageAlign,
  onGreyBackground,
  onFormulaToggle,
}) {
  return (
    <div className={`lh6-toolbarShell ${htmlMode ? "is-html-mode" : ""}`}>
      <div className="lh6-toolbarRow">
        <div className="lh6-toolbarGroup is-select">
          <select className="lh6-select" value={format} onChange={(e) => onFormatChange(e.target.value)} aria-label="Format">
            <option value="p">Paragraph</option>
            <option value="h1">Heading 1</option>
            <option value="h2">Heading 2</option>
            <option value="h3">Heading 3</option>
            <option value="h4">Heading 4</option>
          </select>
        </div>

        <div className="lh6-toolbarGroup">
          <ToolButton active={activeMarks.bold} onClick={onBold} label="Bold" icon="B" />
          <ToolButton active={activeMarks.italic} onClick={onItalic} label="Italic" icon="I" />
        </div>

        <div className="lh6-toolbarGroup">
          <ToolButton active={activeMarks.bulletList} onClick={onBullets} label="Bullet list" icon="•" />
          <ToolButton active={activeMarks.orderedList} onClick={onNumbers} label="Numbered list" icon="1." />
          <ToolButton active={activeMarks.superscript} onClick={onSup} label="Superscript" icon="x²" />
          <ToolButton active={activeMarks.subscript} onClick={onSub} label="Subscript" icon="x₂" />
        </div>

        <div className="lh6-toolbarGroup">
          <ToolButton active={activeMarks.link} onClick={onLink} label="Link" wide />
          <ToolButton active={false} onClick={onInsertImage} label="Bild" wide />
          <ToolButton active={false} onClick={onInsertTable} label="Table" wide />
          <ToolButton active={false} onClick={onHorizontalLine} label="Line" wide />
          <ToolButton active={activeMarks.greyBackground} onClick={onGreyBackground} label="Grauer Hintergrund" icon="BG" />
        </div>

        {imageSelected ? (
          <div className="lh6-toolbarGroup">
            <ToolButton active={imageLayout === "left"} onClick={() => onImageAlign?.("left")} label="Bild links" icon="L" />
            <ToolButton active={imageLayout === "center"} onClick={() => onImageAlign?.("center")} label="Bild mittig" icon="C" />
            <ToolButton active={imageLayout === "right"} onClick={() => onImageAlign?.("right")} label="Bild rechts" icon="R" />
          </div>
        ) : null}

        <div className="lh6-toolbarGroup is-select">
          <select
            className="lh6-sizeSelect"
            value={fontSize}
            onChange={(e) => onFontSizeChange(parseInt(e.target.value, 10))}
            aria-label="Text size"
          >
            {FONT_SIZES.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>

          <select className="lh6-colorSelect" value={color} onChange={(e) => onColor(e.target.value)} aria-label="Farbe">
            {colors.map((c) => (
              <option key={c.value} value={c.value}>
                {c.label}
              </option>
            ))}
          </select>
        </div>

        <div className="lh6-toolbarGroup is-right">
          <ToolButton active={formulaSelected} onClick={onFormulaToggle} label="Formel" wide />
        </div>
      </div>
    </div>
  );
}
